import { Button } from "@tql/ui-components-react/tql/buttons";
import { dotsGrid } from "@tql/ui-components-react/untitled/icons";
import type { MouseEvent } from "react";
import { useCallback, useState } from "react";

import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";

import { QuoteInfoModal } from "./quote-info-modal.tsx";

export function QuoteInfoButton() {
	const isMobile = useIsMobile();
	const [showModal, setShowModal] = useState(false);

	const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
		// Prevent the click from bubbling up to the accordion header, which
		// would otherwise toggle the panel when this button is rendered as
		// the panel's header content.
		event.stopPropagation();
		setShowModal(true);
	}, []);

	if (!isMobile) {
		return null;
	}

	return (
		<>
			<Button
				aria-label={"Quote Info"}
				onClick={handleClick}
				svgIcon={dotsGrid}
				tabIndex={-1}
			/>
			{showModal ? (
				<QuoteInfoModal
					onDismiss={() => {
						setShowModal(false);
					}}
				/>
			) : null}
		</>
	);
}
